import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  DrawerProvider,
  ModalProvider,
  BreakpointProvider,
  MobileProvider,
  NotificationProvider,
  OverlayProvider,
  ApolloWrapper,
  LayoutProvider,
  ServerNotificationsProvider,
  ThemeProvider,
  PromoProvider,
} from "components/common";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SetupContainer from "containers/SetupContainer";
import IdleTimer from "containers/IdleTimer";
import AppRoutes from "routes";
import store from "state/store";
import "./App.css";
import "animate.css";
// Include iovation js
import "./transunion/config";
import "./transunion/loader_only";

// This method will mount the needed component for toastify
toast.configure({
  autoClose: 5000,
});

function App() {
  return (
    <Router basename="dashboard">
      <Provider store={store}>
        <ApolloWrapper>
          <MobileProvider>
            <ThemeProvider>
              <PromoProvider>
                <NotificationProvider>
                  <BreakpointProvider>
                    <DrawerProvider>
                      <ModalProvider>
                        <OverlayProvider>
                          <ServerNotificationsProvider>
                            <LayoutProvider>
                              <IdleTimer>
                                <SetupContainer>
                                  <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <AppRoutes />
                                  </MuiPickersUtilsProvider>
                                </SetupContainer>
                              </IdleTimer>
                            </LayoutProvider>
                          </ServerNotificationsProvider>
                        </OverlayProvider>
                      </ModalProvider>
                    </DrawerProvider>
                  </BreakpointProvider>
                </NotificationProvider>
              </PromoProvider>
            </ThemeProvider>
          </MobileProvider>
        </ApolloWrapper>
      </Provider>
    </Router>
  );
}

export default App;
